import React from 'react';

import { FileOutlined, InfoCircleOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tooltip } from 'antd';

type DisableComponents = {
  tooltip: boolean;
  tooltipTitle?: string;
  button: boolean;
};

type Props = {
  onSubmit: () => void;
  onSubmitDraft: () => void;
  disabledDraft: DisableComponents;
  disabled: DisableComponents;
  isService: boolean;
};

const DraftButtons = ({ onSubmit, onSubmitDraft, disabledDraft, disabled, isService }: Props) => {
  const text = isService
    ? 'Clicando em pronto para vender seu serviço será enviado para moderação e o link de vendas ficará habilitado.'
    : 'Clicando em pronto para vender seu produto será enviado para moderação e o link de vendas ficará habilitado.';
  return (
    <Row justify='end'>
      <Col span={24} key='helper-text' className='mb-3'>
        <Row justify='end'>
          <div className='flex items-center justify-center gap-2 text-[13px] font-bold'>
            <InfoCircleOutlined style={{ fontSize: 20 }} />
            {text}
          </div>
        </Row>
      </Col>
      <Col span={24} key='draft-buttons'>
        <Row justify='end' gutter={[16, 16]}>
          <Col>
            <Tooltip
              placement='top'
              title={
                disabledDraft.tooltip
                  ? ''
                  : (disabledDraft.tooltipTitle ?? 'Preencha o título para poder salvar como rascunho')
              }
            >
              <div>
                <Button
                  id='new-product-draft-button'
                  onClick={() => onSubmitDraft()}
                  icon={<FileOutlined style={{ fontSize: 20 }} />}
                  disabled={disabledDraft.button}
                >
                  Salvar como rascunho
                </Button>
              </div>
            </Tooltip>
          </Col>
          <Col>
            <Tooltip placement='top' title={disabled.tooltip ? '' : 'Preencha os campos obrigatórios para salvar'}>
              <div>
                <Button
                  id='new-product-save-button'
                  type='primary'
                  onClick={() => onSubmit()}
                  icon={<ThunderboltOutlined style={{ fontSize: 20 }} />}
                  disabled={disabled.button}
                >
                  Pronto para vender
                </Button>
              </div>
            </Tooltip>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DraftButtons;
